import { styled } from '@slal/ui';
import { Anchor } from '@slal/ui/navigation';

export const StyledDocumentLink = styled(Anchor)`
    display: flex;
    align-items: center;
    text-decoration: none;
`;
